class WishlistPageRenderer {
  constructor() {
    this.container = document.getElementById('CollectionLoop');
    this.container.innerHTML = '';
    
     // Extract data attributes
    this.buttonStyle = this.container.dataset.btnstyle || '';
    this.buttonSize = this.container.dataset.btnsize || '';
    this.buttonType = this.container.dataset.btntype || '';
    this.buttonText = this.container.dataset.btntext || 'Remove';
    this.textStyle = this.container.dataset.textstyle || '';
    this.anchor = this.container.dataset.anchor || '';
    
    this.renderWishlist();
    this.updateWishlistCount();
  }

  getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

 // Update wishlist count in multiple locations
  updateWishlistCount() {
    const wishlist = this.getWishlist();
    const countSelectors = ['#wt-count', '#wt-count-mobile']; // Add more selectors as needed

    countSelectors.forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) {
        element.textContent = wishlist.length;
      }
    });
  }

  removeFromWishlist(handle, productId) {
    let currentWishlist = this.getWishlist();
    const updatedWishlist = currentWishlist.filter(item => item !== handle);
    this.saveWishlist(updatedWishlist);

    const itemElement = document.getElementById(`item-${productId}`);
    if (itemElement) itemElement.remove();

    this.updateWishlistCount();

    if (updatedWishlist.length === 0) {
      this.container.innerHTML = '<p>Your wishlist is empty.</p>';
    }
  }

  renderWishlist() {
    const wishlist = this.getWishlist();

    if (wishlist.length === 0) {
      this.container.innerHTML = '<p>Your wishlist is empty.</p>';
      return;
    }

    wishlist.forEach((handle,index) => {
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          const hasSecondImage = product.images[1] && product.images[1].trim() !== '';
          const currencyCode = Shopify.currency?.active || 'USD';
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode
          }).format(product.price / 100);

          const orderNumber = index + 1;
          
          const html = `
            <div class="grid__item product-item product-item--swatches product-item--left product-item--outer-text" id="item-${product.id}" data-aos="hero"
                data-aos-anchor="${this.anchor}"
                data-aos-order="${orderNumber}">
              <div class="product-item__image ${hasSecondImage ? 'double__image' : ''}" data-product-image>
                <a href="/products/${product.handle}" class="product-link">
                  <div class="product-item__bg" data-product-image-default="">
                    <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill aos-animate" data-aos="img-in" data-aos-delay="0" data-aos-duration="800" data-aos-anchor="#item-${product.id}" data-aos-easing="ease-out-quart">
                      <img src="${product.images[0]}" loading="lazy" width="400" height="400" alt="${product.title}">
                    </figure>
                  </div>
                  ${hasSecondImage ? `
                  <hover-images class="product-item__bg__under">
                    <div class="product-item__bg__slider" data-hover-slider="">
                      <div class="product-item__bg__slide" data-hover-slide-touch="">
                        <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill">
                          <img src="${product.images[1]}" loading="lazy" width="400" height="400" alt="${product.title}">
                        </figure>
                      </div>
                      <div class="product-item__bg__slide" data-hover-slide="" data-hover-slide-touch="">
                        <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill">
                          <img src="${product.images[1]}" loading="lazy" width="400" height="400" alt="${product.title}">
                        </figure>
                      </div>
                    </div>
                  </hover-images>` : ''}
                </a>
              </div>
              <div class="product-information" data-product-information>
                <div class="product-item__info body-medium">
                  <a href="/products/${product.handle}" class="product-link">
                    <p class="product-item__title">${product.title}</p>
                    <div class="product-item__price__holder">
                      <div class="product-item__price" data-product-price="">
                        <span class="price">
                          <span class="new-price">
                            <small>From</small>
                            ${formattedPrice}
                          </span>
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <button class="wishlist-remove-button btn  ${this.buttonStyle} ${this.buttonSize} ${this.buttonType}" data-handle="${product.handle}" data-id="${product.id}">
                <span class="extended-font-size extended-color" style="${this.textStyle}">
                   ${this.buttonText}
                </span>
              </button>
            </div>
          `;

          this.container.insertAdjacentHTML('beforeend', html);

          const removeBtn = this.container.querySelector(`.wishlist-remove-button[data-id="${product.id}"]`);
          if (removeBtn) {
            removeBtn.addEventListener('click', () => {
              this.removeFromWishlist(product.handle, product.id);
            });
          }
        })
        .catch(err => {
          console.error('Wishlist product fetch failed:', err);
        });
    });
  }
}

// Instantiate the class
new WishlistPageRenderer();
